import React from "react";
import { useNavigate } from "react-router-dom";
import { TwoButton } from "../../../components/attributes/Button";
import { ContextLanguage } from "../../../context/Context.Language";
import {
  TEXT_CONTACT_US,
  TEXT_HOME,
  TEXT_IF_YOU_HAVE_ANY_QUESTIONS,
  TEXT_MY_ORDERS,
  TEXT_ORDER_RECIEVED,
  TEXT_WE_RECIVED_YOUR_ORDER,
} from "../../../utils/useConstants";
import { useIsMobile } from "../../../utils/useIsMobile";
import { ButtonScrollObserver } from "../../../utils/useObserver";
import {
  STYLE_BANNER_BLUE,
  STYLE_BODY_2_REGULAR_80,
  STYLE_BOTTOM_BAR,
  STYLE_BUTTON_BLUE_WFULL,
  STYLE_BUTTON_OUTLINE,
  STYLE_HEAD_TITLE,
  STYLE_LINK_BLUE_NO_MX,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_UNDERLUBE_BLUE_CONTACTUS,
} from "../../../utils/useStyle";
import { AwaitComponent } from "../../../utils/useAutosuzeTextArea";

const Banner = () => {
  const isMobile = useIsMobile();
  return (
    <div
      // className={`w-full h-banner_mb md:h-banner_success_order mb-14 relative mt-4 md:mt-[72px] `}
      className={`${STYLE_BANNER_BLUE} mt-16 md:mt-[72px] relative overflow-hidden rounded-b-[24px]`}
      style={{
        // backgroundImage: `url(/images/bg_blue.png)`,
        backgroundImage: isMobile
          ? `url(/images/mb_s_banner.png)`
          : `url(/images/bg_blue.png)`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "bottom",
        backgroundSize: "cover",
      }}
    >
      {!isMobile && (
        <img
          style={{
            backgroundClip: "content-box",
          }}
          src="/images/success.png"
          className="border-none  h-[197.31px] md:h-img_banner mx-auto absolute bottom-[4px] md:bottom-0 left-1/2 transform -translate-x-1/2 "
          // className={STYLE_IMG_BANNER_ORDER}
        />
      )}
    </div>
  );
};
const Text = ({ setTab }) => {
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <div className={`flex flex-col justify-between  overflow-x-hidden`}>
        <div
          className={`max-w-desktop px-4 md:px-10 xl:px-padding_read mx-auto  bg-white`}
        >
          <div className={STYLE_HEAD_TITLE(language)}>
            {TEXT_ORDER_RECIEVED[language]}
          </div>
          <div className={STYLE_UNDERLUBE_BLUE_CONTACTUS}></div>
          <div
            className={`${STYLE_BODY_2_REGULAR_80(
              language
            )} text-center mb-6 md:mb-11`}
          >
            {TEXT_WE_RECIVED_YOUR_ORDER[language]}
            <div>
              {TEXT_IF_YOU_HAVE_ANY_QUESTIONS[language]}{" "}
              <span
                onClick={() => navigate("/ContactUs")}
                className={`${STYLE_LINK_BLUE_NO_MX}`}
              >
                {TEXT_CONTACT_US[language]}
              </span>
              {language === "EN" && <React.Fragment>.</React.Fragment>}
            </div>
          </div>
        </div>
        <div className="w-full bg-white pb-6 md:pt-0 md:pb-0">
          <div
            className={`${STYLE_BOTTOM_BAR} ${STYLE_MAX_WIDTH_DESKTOP} py-4 md:py-8 ${!isMobile}  `}
          >
            <TwoButton
              classNameCancel={STYLE_BUTTON_OUTLINE}
              classNameAccept={STYLE_BUTTON_BLUE_WFULL}
              titlefirst={
                <div
                  className={`${language === "TH" ? "text-sm-th" : "text-sm"}`}
                >
                  {TEXT_MY_ORDERS[language]}
                </div>
              }
              onClickFirst={() => {
                navigate("/MyOrders");
              }}
              titlesecond={
                <div
                  className={`${language === "TH" ? "text-sm-th" : "text-sm"}`}
                >
                  {TEXT_HOME[language]}
                </div>
              }
              onClickSecond={() => navigate("/")}
            />
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div
        className={`flex flex-col justify-between min-h-[100svh] md:min-h-full overflow-x-hidden bg-white relative`}
      >
        <div>
          <div className={STYLE_HEAD_TITLE(language)}>
            {TEXT_ORDER_RECIEVED[language]}
          </div>
          <div className={STYLE_UNDERLUBE_BLUE_CONTACTUS}></div>
          <div
            className={`${STYLE_BODY_2_REGULAR_80(language)} text-center mb-11`}
          >
            {TEXT_WE_RECIVED_YOUR_ORDER[language]}
            <div>
              {TEXT_IF_YOU_HAVE_ANY_QUESTIONS[language]}{" "}
              <span
                onClick={() => navigate("/ContactUs")}
                className={`${STYLE_LINK_BLUE_NO_MX}`}
              >
                {TEXT_CONTACT_US[language]}
              </span>
              {language === "EN" && <React.Fragment>.</React.Fragment>}
            </div>
          </div>
        </div>
        <div className="w-full bg-white  pb-10 pt-4 md:pt-0 md:pb-0 shadowbottom">
          <div
            className={`${STYLE_BOTTOM_BAR} ${STYLE_MAX_WIDTH_DESKTOP} py-4 md:py-8 ${!isMobile}  `}
          >
            <TwoButton
              className="grid grid-cols-2 h-[50px] md:h-input gap-4 md:gap-6 "
              classNameCancel={STYLE_BUTTON_OUTLINE}
              classNameAccept={STYLE_BUTTON_BLUE_WFULL}
              titlefirst={
                <div
                  className={`${
                    language === "TH" ? "text-base-th" : "text-base"
                  }`}
                >
                  {TEXT_MY_ORDERS[language]}
                </div>
              }
              onClickFirst={() => {
                // setTab(STATE_CONSTANTS_ORDER.ORDER);
                navigate("/MyOrders");
              }}
              titlesecond={
                <div
                  className={`${
                    language === "TH" ? "text-base-th" : "text-base"
                  }`}
                >
                  {TEXT_HOME[language]}
                </div>
              }
              onClickSecond={() => navigate("/")}
            />
          </div>
        </div>
      </div>
    );
  }
};

const OrderSuccess = () => {
  return (
    <div className="space-y-2 md:space-y-4 text-gray-700 bg-white relative  h-full mt-16 md:mt-[72px]    ">
      <Banner />
      <div className="  mt-6.5 md:mt-[41px] " />
      <Text />
    </div>
  );
};
export default OrderSuccess;
